// Core
import { useQuery } from 'react-query';
import { Box, Button, Flex, Grid, Text, Image, useColorMode, useColorModeValue, useDisclosure } from '@chakra-ui/react';
import { NavLink, Link } from 'react-router-dom';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import ticket from 'assets/img/details/ticket.png';
import { ReactComponent as UpgradePlanIcon } from 'assets/svg/upgrade-plan.svg';
import opportunitiesEntryImage from 'assets/img/opportunities/opportunities-entry.png';
import opportunitiesPremiumImage from 'assets/img/opportunities/opportunities-premium.png';
import opportunitiesEliteImage from 'assets/img/opportunities/opportunities-elite.png';

// Components
import Card from 'components/Card/Card';
import { UpgradeIcon, DowngradeIcon } from 'components/Icons/Icons';
import YearlyUpgradeModal from './YearlyUpgradeModal';

const MoreOpportunities = ({userData}) => { 
	const { colorMode, toggleColorMode } = useColorMode();
	const isDark = colorMode === 'dark';

	const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
	const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');
	const textColorSubDowngrade = useColorModeValue('#7787B0', '#8794C2');

	const { isOpen: isOpenYearly, onClose: onCloseYearly, onOpen: onOpenYearly } = useDisclosure();

	const activePlan = userData?.activePlan;

    const getImageByType = (array, type) => {
	    const foundItem = array.find(item => item.type === type);
	    return foundItem ? foundItem.image : null;
	};

	return (
		<Card padding="0" mt="32px" bg="transparent" border={border} boxShadow={boxShadow} overflow="hidden" position="relative">
			<Box p={{base: '16px', md: '20px 20px 20px 20px'}} maxW={{base: '100%', md: '55%'}}>
				<Text variant="header" lineHeight="100%" fontSize={{base: '28', sm: '36px', md: '48px'}}>
					Get more 
					<br /><Text as="span" variant="header-gradient" fontSize={{base: '28', sm: '36px', md: '48px'}}>
						opportunities
						</Text>
				</Text>

				<Text mt="10px" mb={{base: '100px', sm: '0'}}>
					Upgrade your plan and unlock new benefits
				</Text>

				<Button
					onClick={onOpenYearly}
					leftIcon={<UpgradeIcon fontSize="24px" />}
					variant={ isDark ? 'button-lg-g' : 'button-lg' } 
					maxW={{base: '100%', sm: '213px'}} 
					mt="24px">
					Upgrade Now
				</Button>
			</Box>

			<Box zIndex="-1" 
				position="absolute" 
				className="animation-account-opportunities"
				w="100%" h="100%">


				{ isDark &&
					<Box position="absolute" 
						bg="#099BFF" 
						filter="blur(100px)" 
						w="200px" h="200px" position="absolute" 
						top="0" right="0" />
				}
				
				{ isDark ? <Lines className="abstract-lines" style={{ left: '30%', top:'-330px'}} /> 
    			: <LinesWhite className="abstract-lines" style={{ left: '30%', top:'-330px', opacity: 0.3 }} /> }

				<Image 
					position="absolute" 
					src={opportunitiesEntryImage} 
					alt="opportunitiesEntryImage" 
					maxW="160px" 
					w="100%" 
					h="auto" 
					className="animation-account-opportunities-plan1"
					transform="scaleX(-1) rotate(9deg)" 
					bottom="100px"
					right="-46px" />

				<Image 
					position="absolute" 
					src={opportunitiesPremiumImage} 
					alt="opportunitiesPremiumImage" 
					maxW="210px" 
					w="100%" 
					h="auto" 
					className="animation-account-opportunities-plan2"
					transform="rotate(-6deg)" 
					bottom="-95px"
					right="76px" />

				<Image
					position="absolute"
					src={opportunitiesEliteImage}
					alt="opportunitiesEliteImage"
					maxW="272px"
					w="100%"
					h="auto"
					className="animation-account-opportunities-plan3"
					transform="scaleX(-1) rotate(-7deg)"
					bottom="-68px"
					right="-68px" />
			</Box>

			<YearlyUpgradeModal
				isOpen={isOpenYearly}
				onClose={onCloseYearly}
				userData={userData} />
	    </Card>
	);
};

export default MoreOpportunities;